import React, { useEffect, useState } from "react";
import "./Alerts.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchAlerts, resetStateAlerts } from "../../app/slices/alertsSlice";
import LoadingContainer from "../../components/LoadingContainer/LoadingContainer";
import ErrorContainer from "../../components/ErrorContainer/ErrorContainer";

const AlertDetails = () => {
  const {
    data: alertsList,
    status: statusAlerts,
    error: errorAlerts,
  } = useSelector(({ alerts }) => alerts.get);

  const [alert, setAlert] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //use effects
  useEffect(() => {
    dispatch(resetStateAlerts());
    let url = new URL(window.location.href);
    const id = url?.searchParams?.get("id");
    if (id === null || id === undefined) {
      navigate("/not-found");
    } else {
      dispatch(
        fetchAlerts({
          alert_id: id,
        })
      );
    }
    return () => {
      dispatch(resetStateAlerts());
    };
  }, []);

  useEffect(() => {
    if (alertsList?.length > 0) {
      setAlert(alertsList[0]);
    }
  }, [alertsList]);

  return (
    <div className="alert-details app-padding mb-20">
      {statusAlerts !== "loading" && alert !== null && (
        <>
          <img
            src={`${process.env.REACT_APP_SERVER_URL}/uploads/alerts/${alert?.cover_image}`}
            alt=""
          />
          <h1>{alert?.title}</h1>
          <small>Published On:</small>
          <p>{alert?.datePublished}</p>
          <div className="category">
            <h3>Description</h3>
            <div className="mt-5">{alert?.description}</div>
          </div>

          {alert?.attachments?.length > 0 && (
            <div className="category">
              <h3>Attachments</h3>
              <div className="flex-row mt-5">
                {alert?.attachments?.map((attachment) => (
                  <a
                    href={`${process.env.REACT_APP_SERVER_URL}/uploads/alerts/${attachment}`}
                  >
                    <div className="link-chip">{attachment}</div>
                  </a>
                ))}
              </div>
            </div>
          )}

          {alert?.links?.length > 0 && (
            <div className="category mb-30">
              <h3>Links</h3>
              <div className="flex-row mt-5">
                {alert?.links?.map((link) => {
                  var _link = JSON.parse(link);
                  return (
                    <a href={_link?.link}>
                      <div className="link-chip">{_link?.title}</div>
                    </a>
                  );
                })}
              </div>
            </div>
          )}
        </>
      )}

      {statusAlerts === "loading" && (
        <LoadingContainer message={"Loading, please wait ..."} />
      )}

      {errorAlerts !== null && statusAlerts !== "loading" && (
        <ErrorContainer
          message={errorAlerts?.message}
          onReload={() => {
            window.location.href = window.location.href;
          }}
        />
      )}
    </div>
  );
};

export default AlertDetails;
